import React from "react"
import { Paper, Container, Box, Typography, Button } from "@mui/material"
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CloseIcon from "@mui/icons-material/Close";
import {useNavigate} from "react-router-dom"
import { SettingsInputComponent } from "@mui/icons-material";
import { getItemsRemito } from "../api";

export default function ({
  clienteSeleccionado,
  enviar,
  dataRemito,
  hayCliente,
  disBtn,
  setOpen,
  lineasCompletas,
  itemsRemito
}) {
  const navigate = useNavigate()

  return <>
    <Paper
      elevation={0}
      square
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        borderTop: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        zIndex: (t) => t.zIndex.appBar,
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 1.5 }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: { xs: "none", md: "block" } }}
          >
            {clienteSeleccionado
              ? `Cliente: ${clienteSeleccionado.razon_social}`
              : "Complete los datos del remito para guardar"}
          </Typography>
          <Box sx={{ flex: 1 }} />
          <Button variant="text" color="inherit" startIcon={<CloseIcon />}
            onClick={()=> {
              setOpen ? setOpen(false) : navigate("/remitos")
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            disableElevation
            startIcon={<SaveOutlinedIcon />}
            onClick={enviar}
            disabled={!dataRemito.puntoVenta || !dataRemito.nroComprobante || !dataRemito.fecha || !dataRemito.id_sucursal_remite || !dataRemito.id_chofer || !hayCliente  || disBtn || !lineasCompletas ||(lineasCompletas < itemsRemito.length)}  
          >
            Guardar remito
          </Button>
        </Box>
      </Container>
    </Paper>

  </>
}